/**
 * Flows mode panel. Inventory, Pulse, Gallery, Sources, and Composer
 * live in FlowStudioSidebar. formatTriggerSummary stays here for the
 * flow document.
 */

import type { MouseEvent } from 'react'
import { FlowStudioSidebar } from '@/components/features/flows/flow-studio-sidebar'
import type { Flow } from '@/lib/api'
import { formatCronExpr } from '@/lib/cron-label'

export function formatTriggerSummary(triggers: Flow['triggers']): string {
  if (!triggers || triggers.length === 0) return 'No triggers'

  const trigger = triggers[0]
  if (trigger.id === 'schedule.cron' && trigger.config.expr) {
    const expr = String(trigger.config.expr)
    const timezone = typeof trigger.config.timezone === 'string'
      ? trigger.config.timezone
      : 'America/Los_Angeles'
    return formatCronExpr(expr, timezone) ?? `Cron: ${expr}`
  }

  return trigger.id
}

export interface FlowsManagerProps {
  onOpenDocument?: (documentId: string, event?: MouseEvent) => void
  activeDocumentPath?: string | null
  activeDocumentId?: string | null
  dense?: boolean
}

export function FlowsManager({
  onOpenDocument = () => {},
  activeDocumentId = null,
  dense = false,
}: FlowsManagerProps) {
  return (
    <FlowStudioSidebar
      onOpenDocument={onOpenDocument}
      activeDocumentId={activeDocumentId}
      dense={dense}
    />
  )
}
